import { mdiCheckboxBlankCircleOutline } from '@mdi/js'

const themeConfig = {
  app: {
    // name: 'Marketa Chat',
    // logo: require('@/assets/images/svg/Happy Homes primary.svg'),
    name: 'Marketa Chat',
    logo: require('@/assets/images/svg/SuperWA-Logo-1.svg'),
    isDark: false,
    isRtl: false,
    contentLayoutNav: 'vertical', // vertical, horizontal
    routeTransition: 'scroll-x-transition', // https://vuetifyjs.com/en/styles/transitions/#api
    // ! `semi-dark` isn't available for horizontal nav menu
    skinVariant: 'bordered', // default, bordered, semi-dark
    contentWidth: 'full',
  },
  menu: {
    isMenuHidden: false,
    isVerticalNavMini: false,
    verticalMenuAccordion: true,
    groupChildIcon: mdiCheckboxBlankCircleOutline,
    horizontalNavMenuGroupOpenOnHover: true,
  },
  appBar: {
    /*
    ! In Content Layout Horizontal Nav type `hidden` value won't work
    ! In Content Layout Horizontal Nav type value of `type` will affect both Appbar and Horizontal Navigation Menu
    */
    type: 'fixed', // fixed, static, hidden
    isBlurred: true,
  },
  footer: {
    type: 'static', // fixed, static, hidden
  },
  themes: {
    light: {
      primary: '#1F979E',
      accent: '#1F979E',
      secondary: '#EEF1F4',
      // primary: '#F15858',
      // accent: '#F15858',
      // secondary: '#2775EC',
      success: '#2ED47A',
      info: '#16B1FF',
      warning: '#FFB400',
      error: '#FF4C51',
      otpText: '#3D3939',
    },
    dark: {
      primary: '#1F979E',
      accent: '#1F979E',
      secondary: '#EEF1F4',
      // primary: '#F15858',
      // accent: '#F15858',
      // secondary: '#2775EC',
      success: '#2ED47A',
      info: '#16B1FF',
      warning: '#FFB400',
      error: '#FF4C51',
      otpText: '#FFFFFF',
    },
  },
}

export default themeConfig
